import {
  ChapterDto,
  LocalizedProperty,
  PurchaseableSubjectStudentDto,
  State,
  SubjectCourseDurationDto,
  SubjectDto,
} from "../../interfaces";
import { MediaDto } from "../../interfaces/media";
import { Paginated, SelectListDto } from "../../models";
import {
  ADD_SUBJECT,
  ADD_SUBJECT_ERROR,
  ADD_SUBJECT_SUCCESS,
  ActionTypes,
  COPY_CUT_SUBJECT,
  COPY_CUT_SUBJECT_ERROR,
  COPY_CUT_SUBJECT_SUCCESS,
  DELETE_SUBJECT,
  DELETE_SUBJECT_CONSENT,
  DELETE_SUBJECT_ERROR,
  DELETE_SUBJECT_SUCCESS,
  GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT,
  GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_ERROR,
  GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_SUCCESS,
  GET_SUBJECT,
  GET_SUBJECTS,
  GET_SUBJECTS_BY_GRADE,
  GET_SUBJECTS_BY_GRADE_ERROR,
  GET_SUBJECTS_BY_GRADE_SUCCESS,
  GET_SUBJECTS_ERROR,
  GET_SUBJECTS_SUCCESS,
  GET_SUBJECT_ERROR,
  GET_SUBJECT_LIST_BY_GRADE,
  GET_SUBJECT_LIST_BY_GRADE_ERROR,
  GET_SUBJECT_LIST_BY_GRADE_SUCCESS,
  GET_SUBJECT_SUCCESS,
  RESET_COPY_CUT_SUBJECT,
  RESET_PURCHASEABLE_SUBJECTS_FOR_STUDENT,
  RESET_SUBJECTS_BY_GRADE,
  RESET_SUBJECT_LIST_BY_GRADE,
  TOGGLE_SUBJECT_STATE,
  TOGGLE_SUBJECT_STATE_ERROR,
  TOGGLE_SUBJECT_STATE_SUCCESS,
  UPDATE_SUBJECT,
  UPDATE_SUBJECT_ERROR,
  UPDATE_SUBJECT_SUCCESS,
  UPLOAD_SUBJECT_CONTENT_IMAGE,
  UPLOAD_SUBJECT_CONTENT_IMAGE_ERROR,
  UPLOAD_SUBJECT_CONTENT_IMAGE_SUCCESS,
  UPLOAD_SUBJECT_HOME_IMAGE,
  UPLOAD_SUBJECT_HOME_IMAGE_ERROR,
  UPLOAD_SUBJECT_HOME_IMAGE_SUCCESS,
} from "./actionTypes";

export class SubjectState {
  subjects!: State<Paginated<SubjectDto>>;
  subject!: State<SubjectDto>;
  addSubject!: State<any>;
  updateSubject!: State<any>;
  deleteSubject!: State<any>;
  subjectsByGrade!: State<SubjectDto[]>;
  homeImage!: State<File>;
  contentImage!: State<File>;
  uploadSubjectNote: State<File>;
  subjectNote: State<MediaDto>;
  deleteSubjectNote: State<any>;
  copyCutSubject!: State<any>;
  toggleSubjectState: any;
  subjectListByGrade: State<SelectListDto[]>;
  purchaseableSubjectsForStudent: State<PurchaseableSubjectStudentDto[]>;
  constructor() {
    this.subjects = {
      loading: false,
      error: null,
      success: false,
    };
    this.subject = {
      loading: false,
      error: null,
      success: false,
    };
    this.addSubject = {
      loading: false,
      error: null,
      success: false,
    };
    this.updateSubject = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteSubject = {
      loading: false,
      error: null,
      success: false,
    };
    this.subjectsByGrade = {
      loading: false,
      error: null,
      success: false,
    };
    this.homeImage = {
      loading: false,
      error: null,
      success: false,
    };
    this.contentImage = {
      loading: false,
      error: null,
      success: false,
    };
    this.uploadSubjectNote = {
      loading: false,
      error: null,
      success: false,
    };
    this.subjectNote = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteSubjectNote = {
      loading: false,
      error: null,
      success: false,
    };
    this.copyCutSubject = {
      loading: false,
      error: null,
      success: false,
    };
    this.toggleSubjectState = {
      loading: false,
      error: null,
      success: false,
    };
    this.subjectListByGrade = {
      loading: false,
      error: null,
      success: false,
    };
    this.purchaseableSubjectsForStudent = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: SubjectState = new SubjectState();

export const subject = (
  state: SubjectState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_SUBJECTS_BY_GRADE:
      state = {
        ...state,
        subjectsByGrade: {
          ...state.subjectsByGrade,
          loading: true,
          success: false,
          error: null,
        },
        subject: {
          ...state.subject,
          loading: false,
          success: false,
          error: null,
        },
        addSubject: {
          ...state.addSubject,
          loading: false,
          success: false,
          error: null,
        },
        updateSubject: {
          ...state.updateSubject,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SUBJECTS_BY_GRADE_SUCCESS:
      state = {
        ...state,
        subjectsByGrade: {
          ...state.subjectsByGrade,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SUBJECTS_BY_GRADE_ERROR:
      state = {
        ...state,
        subjectsByGrade: {
          ...state.subjectsByGrade,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_SUBJECTS_BY_GRADE:
      state = {
        ...state,
        subjectsByGrade: {
          ...state.subjectsByGrade,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_SUBJECTS:
      state = {
        ...state,
        subjects: {
          ...state.subjects,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SUBJECTS_SUCCESS:
      state = {
        ...state,
        subjects: {
          ...state.subjects,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SUBJECTS_ERROR:
      state = {
        ...state,
        subjects: {
          ...state.subjects,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_SUBJECT:
      state = {
        ...state,
        subject: {
          ...state.subject,
          loading: true,
          success: false,
          error: null,
          response: undefined,
        },
        addSubject: {
          ...state.addSubject,
          loading: false,
          success: false,
          error: null,
        },
        updateSubject: {
          ...state.updateSubject,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SUBJECT_SUCCESS:
      state = {
        ...state,
        subject: {
          ...state.subject,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SUBJECT_ERROR:
      state = {
        ...state,
        subject: {
          ...state.subject,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case ADD_SUBJECT:
      state = {
        ...state,
        addSubject: {
          ...state.addSubject,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_SUBJECT_SUCCESS:
      state = {
        ...state,
        addSubject: {
          ...state.addSubject,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case ADD_SUBJECT_ERROR:
      state = {
        ...state,
        addSubject: {
          ...state.addSubject,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPDATE_SUBJECT:
      state = {
        ...state,
        updateSubject: {
          ...state.updateSubject,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_SUBJECT_SUCCESS:
      state = {
        ...state,
        updateSubject: {
          ...state.updateSubject,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case UPDATE_SUBJECT_ERROR:
      state = {
        ...state,
        updateSubject: {
          ...state.updateSubject,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_SUBJECT_CONSENT:
      state = {
        ...state,
        deleteSubject: {
          ...state.deleteSubject,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_SUBJECT:
      state = {
        ...state,
        deleteSubject: {
          ...state.deleteSubject,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_SUBJECT_SUCCESS:
      state = {
        ...state,
        deleteSubject: {
          ...state.deleteSubject,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case DELETE_SUBJECT_ERROR:
      state = {
        ...state,
        deleteSubject: {
          ...state.deleteSubject,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPLOAD_SUBJECT_HOME_IMAGE:
      state = {
        ...state,
        homeImage: {
          ...state.homeImage,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPLOAD_SUBJECT_HOME_IMAGE_SUCCESS:
      state = {
        ...state,
        homeImage: {
          ...state.homeImage,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
        subject: {
          ...state.subject,
          response: {
            name: state.subject.response?.name as LocalizedProperty,
            homeImage: action.payload,
            contentImage: state.subject.response?.contentImage as MediaDto,
            chapters: state.subject.response?.chapters as ChapterDto[],
            subjectCourseDuration: state.subject.response
              ?.subjectCourseDuration as SubjectCourseDurationDto[],
            createdAt: state.subject.response?.createdAt as Date,
            createdBy: state.subject.response?.createdBy as string,
            deletedAt: state.subject.response?.deletedAt as Date,
            deletedBy: state.subject.response?.deletedBy as string,
            id: state.subject.response?.id as string,
            isActive: state.subject.response?.isActive as boolean,
            modifiedAt: state.subject.response?.modifiedAt as Date,
            modifiedBy: state.subject.response?.modifiedBy as string,
            isFree: state.subject.response?.isFree as boolean,
            feature: {
              featureLectures: state.subject.response?.feature
                ?.featureLectures as boolean,
              featureExams: state.subject.response?.feature
                ?.featureExams as boolean,
              featureSkills: state.subject.response?.feature
                ?.featureSkills as boolean,
              featureFlashCards: state.subject.response?.feature
                ?.featureFlashCards as boolean,
              featureNotes: state.subject.response?.feature
                ?.featureNotes as boolean,
              featureAskTeacher: state.subject.response?.feature
                ?.featureAskTeacher as boolean,
              featureLiveLecture: state.subject.response?.feature
                ?.featureLiveLecture as boolean,
              featureNotesDelivery: state.subject.response?.feature
                ?.featureNotesDelivery as boolean,
              featureFlashCardDelivery: state.subject.response?.feature
                ?.featureFlashCardDelivery as boolean,
              featureStatistics: state.subject.response?.feature
                ?.featureStatistics as boolean,
            },
          },
        },
      };
      break;
    case UPLOAD_SUBJECT_HOME_IMAGE_ERROR:
      state = {
        ...state,
        homeImage: {
          ...state.homeImage,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPLOAD_SUBJECT_CONTENT_IMAGE:
      state = {
        ...state,
        contentImage: {
          ...state.contentImage,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPLOAD_SUBJECT_CONTENT_IMAGE_SUCCESS:
      state = {
        ...state,
        contentImage: {
          ...state.contentImage,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
        subject: {
          ...state.subject,
          response: {
            name: state.subject.response?.name as LocalizedProperty,
            homeImage: state.subject.response?.homeImage as MediaDto,
            contentImage: action.payload,
            chapters: state.subject.response?.chapters as ChapterDto[],
            subjectCourseDuration: state.subject.response
              ?.subjectCourseDuration as SubjectCourseDurationDto[],
            createdAt: state.subject.response?.createdAt as Date,
            createdBy: state.subject.response?.createdBy as string,
            deletedAt: state.subject.response?.deletedAt as Date,
            deletedBy: state.subject.response?.deletedBy as string,
            id: state.subject.response?.id as string,
            isActive: state.subject.response?.isActive as boolean,
            modifiedAt: state.subject.response?.modifiedAt as Date,
            modifiedBy: state.subject.response?.modifiedBy as string,
            isFree: state.subject.response?.isFree as boolean,
            feature: {
              featureLectures: state.subject.response?.feature
                ?.featureLectures as boolean,
              featureExams: state.subject.response?.feature
                ?.featureExams as boolean,
              featureSkills: state.subject.response?.feature
                ?.featureSkills as boolean,
              featureFlashCards: state.subject.response?.feature
                ?.featureFlashCards as boolean,
              featureNotes: state.subject.response?.feature
                ?.featureNotes as boolean,
              featureAskTeacher: state.subject.response?.feature
                ?.featureAskTeacher as boolean,
              featureLiveLecture: state.subject.response?.feature
                ?.featureLiveLecture as boolean,
              featureNotesDelivery: state.subject.response?.feature
                ?.featureNotesDelivery as boolean,
              featureFlashCardDelivery: state.subject.response?.feature
                ?.featureFlashCardDelivery as boolean,
              featureStatistics: state.subject.response?.feature
                ?.featureStatistics as boolean,
            },
          },
        },
      };
      break;
    case UPLOAD_SUBJECT_CONTENT_IMAGE_ERROR:
      state = {
        ...state,
        contentImage: {
          ...state.contentImage,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case COPY_CUT_SUBJECT:
      state = {
        ...state,
        copyCutSubject: {
          ...state.copyCutSubject,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case COPY_CUT_SUBJECT_SUCCESS:
      state = {
        ...state,
        copyCutSubject: {
          ...state.copyCutSubject,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case COPY_CUT_SUBJECT_ERROR:
      state = {
        ...state,
        copyCutSubject: {
          ...state.copyCutSubject,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_COPY_CUT_SUBJECT:
      state = {
        ...state,
        copyCutSubject: {
          ...state.copyCutSubject,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_SUBJECT_STATE:
      state = {
        ...state,
        toggleSubjectState: {
          ...state.toggleSubjectState,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_SUBJECT_STATE_SUCCESS:
      state = {
        ...state,
        toggleSubjectState: {
          ...state.toggleSubjectState,
          loading: false,
          error: null,
          success: true,
        },
        subjectsByGrade: {
          ...state.subjectsByGrade,
          response: state.subjectsByGrade?.response?.map(
            (subject: SubjectDto) => {
              if (subject.id === action.payload.id)
                return { ...subject, isActive: !subject.isActive };
              return subject;
            }
          ),
        },
      };
      break;
    case TOGGLE_SUBJECT_STATE_ERROR:
      state = {
        ...state,
        toggleSubjectState: {
          ...state.toggleSubjectState,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_SUBJECT_LIST_BY_GRADE:
      state = {
        ...state,
        subjectListByGrade: {
          ...state.subjectListByGrade,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SUBJECT_LIST_BY_GRADE_SUCCESS:
      state = {
        ...state,
        subjectListByGrade: {
          ...state.subjectListByGrade,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SUBJECT_LIST_BY_GRADE_ERROR:
      state = {
        ...state,
        subjectListByGrade: {
          ...state.subjectListByGrade,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_SUBJECT_LIST_BY_GRADE:
      state = {
        ...state,
        subjectListByGrade: {
          ...state.subjectListByGrade,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT:
      state = {
        ...state,
        purchaseableSubjectsForStudent: {
          ...state.purchaseableSubjectsForStudent,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_SUCCESS:
      state = {
        ...state,
        purchaseableSubjectsForStudent: {
          ...state.purchaseableSubjectsForStudent,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_PURCHASEABLE_SUBJECTS_FOR_STUDENT_ERROR:
      state = {
        ...state,
        purchaseableSubjectsForStudent: {
          ...state.purchaseableSubjectsForStudent,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_PURCHASEABLE_SUBJECTS_FOR_STUDENT:
      state = {
        ...state,
        purchaseableSubjectsForStudent: {
          ...state.purchaseableSubjectsForStudent,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};
